import React from "react";
import "../../styles/home.css";
import CodingImage from "../Assets/gummy-coding.svg";
import TeamworkImage from "../Assets/fogg-teamwork.png";
import SoftwareImage from "../Assets/software-engineer.svg";
const HomePage = () => {
  return (
    <div className="container">
      <div className="row heading-quote">
        <h1 className="quote">
          <p  className="mainText">
            Let’s go <span>invent tomorrow</span> instead of
            <br /> worrying about what happened yesterday.
          </p>
        </h1>
      </div>
      <div className="row heading-feature">
        <div className="col-md-6 d-flex">
          <img
          draggable="false"
            className="coding-image responsive-image"
            src={CodingImage}
            alt="ISTE Coding"
          />
        </div>
        <div className="col-md-6 heading-content d-flex">
          <h3 className="heading-paragraph">
            We are a Technical Society in SRM, Delhi NCR and we focus to spread
            awareness about how powerful and vast Technology really is.
          </h3>
        </div>
      </div>
      <hr />
      <div className="row heading-feature">
        <div className="col-md-6 heading-content d-flex">
          <h3 className="heading-paragraph">
            Coming together is a beginning. Keeping together is progress.
            Working together is success. We beleive in teamwork and have a
            community of over 150+ members.
          </h3>
        </div>
        <div className="col-md-6 d-flex">
          <img
          draggable="false"
            className="coding-image responsive-image"
            src={TeamworkImage}
            alt="ISTE Coding"
          />
        </div>
      </div>
      <hr />
      <div className="row heading-feature home-bottom">
        <div className="col-md-6 d-flex">
          <img
          draggable="false"
            className="coding-image responsive-image"
            src={SoftwareImage}
            alt="ISTE Coding"
          />
        </div>
        <div className="col-md-6 heading-content d-flex">
          <h3 className="heading-paragraph">
            We have various Coding events, fun discord nights, gaming events and
            much more. We are way more than just Technology.
          </h3>
        </div>
      </div>
    </div>
  );
};
export default HomePage;
